import styled from "styled-components";

export const DivMarginTop = styled.div<{ mt: number }>`
  margin-top: ${(props) => props.mt}rem;
`;
